import Popover from 'trunks/vue/admin/components/libs/popover.js';

export default {
  components: {
    Popover,
  },

  props: {
    currentSearchFactor: {
      type: Object,
      required: true,
    },
    popoverFieldOptions: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  template: `
    <div class="form-field-input-container justify-box">
      <div class="form-field-popover">
        <Popover position='bottom left'
                :caret='false'
                :customClass="['cascaded-select-popover']"
                type='select'
                size='default'
                ref='selectionPopoveRef'
                :blockContent='true'>
          <template slot='trigger'>
            <slot name='trigger'>
              <div class="input-control right-addon">
                <div class="controlled-input" v-show='displayValue'>{{ displayValue }}</div>
                <div class="controlled-input placeholder" v-show='!displayValue'>请选择</div>
                <div class="addon">
                  <i class="slp-caret-down"></i>
                </div>
              </div>
            </slot>
          </template>
          <template slot='content'>
            <div class="list">
              <div class="list-item justify-between"
                   v-for='option in popoverFieldOptions'
                   v-if='_getHoldName(option.type)'
                   :key='option.id'
                   @click='optionClicked(option)'>
                  <span class="content text-ellipsis">{{ option.name }}</span>
                  <i :class="[option.id == selectId ? 'slp-check' : 'slp-empty']"></i>
              </div>
            </div>
          </template>
        </Popover>
      </div>
      <div class="checkbox-content mr-8 ml-4">
        <label class="option-item vertical-middle clickable text-normal">
          <input type="checkbox" hidden='true' v-model="currentSearchFactor.full_match" ref="radioInput"/>
          <i class="slp-square-o"></i>
          <label class="ml-2" @click="toggleExactMatch">完全匹配</label>
        </label>
      </div>
      <div class="icon-btn-group">
        <div class="btn btn-primary icon-btn ml-2" @click="addSearchFactor">
          <i class="slp-plus-circle"></i>
        </div>
        <div class="btn icon-btn ml-2" @click="deleteSearchFactor">
          <i class="slp-minus-circle"></i>
        </div>
      </div>
    </div>
  `,

  computed: {
    displayValue() {
      return (_.find(this.popoverFieldOptions, (field) => field.id === this.currentSearchFactor.field_id)).name;
    },

    selectId() {
      return this.currentSearchFactor.field_id;
    },
  },

  methods: {
    addSearchFactor() {
      const searchFactor = {
        id: Skylark.Helpers.Utilities.uuid(),
        field_id: -2,
        field_type: 'Field::HoldUser',
        full_match: false,
        select_id: this.selectId,
      };

      this.$emit('addSearchFactor', searchFactor);
    },

    deleteSearchFactor() {
      this.$emit('deleteSearchFactor', this.currentSearchFactor);
    },

    optionClicked(option) {
      this.currentSearchFactor.field_type = option.type;
      this.currentSearchFactor.field_id = option.id;
      this.$refs.selectionPopoveRef.close();
    },

    toggleExactMatch() {
      this.$emit('toggleResetSearchFactorExactMatch', this.currentSearchFactor);
    },

    _getHoldName(choice) {
      return Skylark.Helpers.t(`field.response_search_fields.${choice}`);
    },
  },
};
